import {
  DEPOSIT_BONUS_PATHNAME,
  DYNAMIC_DEPOSIT_BONUS_PATHNAME,
  NO_DEPOSIT_BONUS_PATHNAME,
  REFER_A_FRIEND_PATHNAME,
  TRADING_BONUS_PATHNAME,
  REDEPOSIT_PATHNAME,
  WELCOME_BONUS_PATHNAME,
  LOSS_RECOVER_PATHNAME,
  OFFLINE_REWARDS_PATHNAME,
  FUNDS_GROWTH_PROMO_PATHNAME,
  VPS_REFUND,
  TRADING_REWARDS_PATHNAME,
  LUCKY_DRAW_PATHNAME,
  TRADING_CONTEST_PATHNAME,
} from '@/constants/route'

export const PROMOTION_TYPE = {
  NO_DEPOSIT_BONUS: 'NO_DEPOSIT_BONUS',
  REFER_A_FRIEND_V10: 'REFER_A_FRIEND_10',
  DEPOSIT_BONUS_V1: 'DEPOSIT_BONUS_1',
  TRADING_BONUS: 'TRADING_BONUS',
  NO_DEPOSIT_BONUS_2: 'NO_DEPOSIT_BONUS_2',
  RE_DEPOSIT_BONUS: 'RE_DEPOSIT_BONUS',
  WELCOME_BONUS: 'WELCOME_BONUS',
  LOSS_RECOVER: 'LOSS_RECOVERY',
  USDT_DEPOSIT_CASHBACK: 'USDT_DEPOSIT_CASHBACK',
  TRADING_CONTEST: 'TRADING_CONTEST',
  OFFLINE_REWARDS: 'OFFLINE_REWARDS',
  FUNDS_GROWTH_PROMO_V2: 'FUNDS_GROWTH_PROMO_V2',
  VPS_REFUND: 'VPS_REFUND',
  TRADING_REWARDS: 'TRADING_REWARDS',
  NO_DEPOSIT_BONUS_3: 'NO_DEPOSIT_BONUS_3',
  LUCKY_DRAW_V2: 'LUCKY_DRAW_V2',
  TRADING_CONTEST: 'TRADING_CONTEST',
}

export const PROMOTION_TYPE_PATH_MAP = {
  [PROMOTION_TYPE.NO_DEPOSIT_BONUS]: NO_DEPOSIT_BONUS_PATHNAME,
  [PROMOTION_TYPE.REFER_A_FRIEND_V10]: REFER_A_FRIEND_PATHNAME,
  [PROMOTION_TYPE.DEPOSIT_BONUS_V1]: DYNAMIC_DEPOSIT_BONUS_PATHNAME,
  [PROMOTION_TYPE.TRADING_BONUS]: TRADING_BONUS_PATHNAME,
  [PROMOTION_TYPE.NO_DEPOSIT_BONUS_2]: NO_DEPOSIT_BONUS_PATHNAME,
  [PROMOTION_TYPE.RE_DEPOSIT_BONUS]: REDEPOSIT_PATHNAME,
  [PROMOTION_TYPE.WELCOME_BONUS]: WELCOME_BONUS_PATHNAME,
  [PROMOTION_TYPE.LOSS_RECOVER]: LOSS_RECOVER_PATHNAME,
  [PROMOTION_TYPE.OFFLINE_REWARDS]: OFFLINE_REWARDS_PATHNAME,
  [PROMOTION_TYPE.FUNDS_GROWTH_PROMO_V2]: FUNDS_GROWTH_PROMO_PATHNAME,
  [PROMOTION_TYPE.VPS_REFUND]: VPS_REFUND,
  [PROMOTION_TYPE.TRADING_REWARDS]: TRADING_REWARDS_PATHNAME,
  [PROMOTION_TYPE.NO_DEPOSIT_BONUS_3]: NO_DEPOSIT_BONUS_PATHNAME,
  [PROMOTION_TYPE.LUCKY_DRAW_V2]: LUCKY_DRAW_PATHNAME,
  [PROMOTION_TYPE.TRADING_CONTEST]: TRADING_CONTEST_PATHNAME,
}

export const PROMOTION_WITH_CHILDS = [
  {
    type: PROMOTION_TYPE.DEPOSIT_BONUS_V1,
    key: 'menu.depositBonus',
  },
  {
    type: PROMOTION_TYPE.OFFLINE_REWARDS,
    key: 'menu.offlineRewards',
  },
  {
    type: PROMOTION_TYPE.TRADING_REWARDS,
    key: 'menu.tradingRewards',
  },
  {
    type: PROMOTION_TYPE.NO_DEPOSIT_BONUS_3,
    key: 'menu.noDepositBonus',
  },
  {
    type: PROMOTION_TYPE.LUCKY_DRAW_V2,
    key: 'menu.luckyDraw',
  },
  {
    type: PROMOTION_TYPE.TRADING_CONTEST,
    key: 'menu.tradingContest',
  },
]

export const NDB_CAMPAIGN_IDS = [10, 24]

export const REDEPOSIT_BONUS_CREDIT_TO_BALANCE_ID = 19
export const REDEPOSIT_BONUS_ID = 20
export const FUNDS_GROWTH_PROMO_ID = 53

export const tradingRewardsEnum = {
  TIERED: 'tiered',
  NETDEPOSIT: 'netDeposit',
  CUMULATIVE: 'cumulative',
  PROFITORDER: 'profitOrder',
  PROPORTION: 'proportion',
  TRADINGLOTS: 'tradingLots',
  NOTIONALVOLUME: 'notionalVolume',
}
